import actionTypes from '../constants/actionTypes';
import createFetchingHandlers from '../../../../utils/createFetchingHandlers';
import createListReducer from '../../../../utils/createListReducer';

const { CLOSURE_TRANSACTIONS_FETCH, CLOSURE_TRANSACTIONS_SUCCESS, CLOSURE_TRANSACTIONS_ERROR } = actionTypes;

const initialState = {
  data: [],
  metadata: {},
};

const fetchingData = createFetchingHandlers([CLOSURE_TRANSACTIONS_FETCH, CLOSURE_TRANSACTIONS_SUCCESS, CLOSURE_TRANSACTIONS_ERROR], () => [
  'metadata',
  'fetchingData',
]);
const getDataHandler = {
  [CLOSURE_TRANSACTIONS_SUCCESS]: (state, action) => {
    const outputState = { ...state };
    outputState.data = { ...action?.payload };
    return { ...outputState };
  },
};

export default createListReducer(initialState, [fetchingData, getDataHandler]);
